import { AttributeDefinition } from '../attributes/attributeDefinition';
import { SurveyQuestion } from './survey-question';

export class SurveyDefinition {
  public id: string;
  public title: string;
  public publicTitle: string;
  public introduction: string;
  public confirmationTitle: string;
  public confirmation: string;
  private _questions: SurveyQuestion[] = [];
  public isAnonymous: boolean;
  public isArchived: boolean;
  public hasExpired: boolean;
  public isPrivate: boolean;

  constructor() {}

  public get questions(): SurveyQuestion[] {
    return this._questions;
  }
  private setQuestions(value: SurveyQuestion[]) {
    this._questions = value.map((question) => {
      if (question) {
        return SurveyQuestion.parse(question);
      }
    });
  }

  private updateQuestions(updatedQuestions: SurveyQuestion[]) {
    //updates the existing questions
    updatedQuestions.forEach((q) => {
      let index = this._questions.findIndex(
        (x) => x.attributeDefinition.id == q.attributeDefinition.id
      );
      if (index != -1) {
        this._questions[index].attributeDefinition = AttributeDefinition.parse(
          q.attributeDefinition
        );
        this._questions[index].isReadOnly = q.isReadOnly;
        this._questions[index].showCurrentValue = q.showCurrentValue;
        this._questions[index].isHidden = q.isHidden;
        this._questions[index].conditions = q.conditions;
        this._questions[index].descriptionOverride = q.descriptionOverride;
        this._questions[index].isRequired = q.isRequired;
      } else {
        //adds a new questions
        this._questions.push(SurveyQuestion.parse(q));
      }
    });

    //removes  questions
    this._questions.forEach((q) => {
      let index = updatedQuestions.findIndex(
        (x) => x.attributeDefinition.id == q.attributeDefinition.id
      );
      if (index == -1) {
        this._questions.splice(this._questions.indexOf(q), 1);
      }
    });
  }
  private setData(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.publicTitle = data.publicTitle;
    this.introduction = data.introduction;
    this.isAnonymous = data.isAnonymous;
    this.isArchived = data.isArchived;
    this.hasExpired = data.hasExpired;
    this.confirmationTitle = data.confirmationTitle;
    this.isPrivate = data.isPrivate;
    if (!data.confirmation) {
      this.confirmation = 'Thank you for completing the survey.';
    } else {
      this.confirmation = data.confirmation;
    }
  }
  public update(data: SurveyDefinition) {
    if (!data) return null;
    this.setData(data);

    this.updateQuestions(data.questions);
    return this;
  }
  public static parse(data: any): SurveyDefinition {
    if (!data) return null;

    let survey = new SurveyDefinition();
    survey.setData(data);

    survey.setQuestions(data.questions);
    return survey;
  }

  public moveQuestion(oldIndex: number, newIndex: number) {
    let movedValue = this._questions.splice(oldIndex, 1);
    this._questions.splice(newIndex, 0, ...movedValue);
  }
}
